import { IHeader, IRow, IRemoteTableColumn } from './RemoteTable.types';

export const getRows = (data: any[], columns: IRemoteTableColumn[]) => {
  const result: IRow[] = [];
  data.forEach((row, index) => {
    const resultRow: IRow = {
      key: index.toString(),
      cells: []
    };
    columns.forEach(column => {
      resultRow.cells.push({
        rowStyle: column.rowStyle,
        align: column.align ?? 'left',
        hide: column.hide,
        columnKey: column.key,
        value: column.custom ? column.customComponent(row) : row[column.key]
      });
    });
    result.push(resultRow);
  });
  return result;
};

export const getHeader = (columns: IRemoteTableColumn[]) => {
  if (!columns) {
    return null;
  }
  const resultHeader: IHeader = {
    cells: []
  };
  columns.forEach(column => {
    resultHeader.cells.push({
      hide: column.hide,
      headerStyle: column.headerStyle,
      columnKey: column.key,
      value: column.name,
      disableSort: column.disableSort
    });
  });
  return resultHeader;
};
